import React from "react";
import "./PrivacyPolicySellDeliver.css";

const PrivacyPolicySellDeliver = () => {
  return (
    <div className="privacy-policy-wrapper">
      <div className="privacy-policy-container">
        <header className="privacy-header">
          <h1 className="privacy-app-name">SellDeliver</h1>
          <p className="privacy-tagline">Privacy Policy</p>
        </header>

        <div className="privacy-content">
          <div className="last-updated">Last updated: September 17, 2026</div>

          <section className="privacy-section">
            <h2> Introduction</h2>
            <p>
              Welcome to SellDeliver. We respect your privacy and are committed to protecting 
              your personal data. This Privacy Policy explains how we collect, use, and safeguard 
              your information when you use our mobile application.
            </p>
          </section>

          <section className="privacy-section">
            <h2>Information We Collect</h2>
            
            <div className="subsection">
              <h3>2.1 Information You Provide</h3>
              <ul>
                <li>Account information (name, email, phone number)</li>
                <li>Contact information for delivery purposes</li>
                <li>Payment information (processed securely through payment processors)</li>
                <li>Communications with our support team</li>
              </ul>
            </div>

            <div className="subsection">
              <h3>2.2 Information Collected Automatically</h3>
              <ul>
                <li>Device information (model, OS version, unique device identifiers)</li>
                <li>Log data (IP address, browser type, pages visited)</li>
                <li>Usage data (features used, time spent in app)</li>
                <li>Location data (only with your permission, for delivery services)</li>
              </ul>
            </div>
          </section>

          <section className="privacy-section">
            <h2> How We Use Your Information</h2>
            <ul>
              <li>To provide and maintain our services</li>
              <li>To process transactions and send related information</li>
              <li>To notify you about changes to our service</li>
              <li>To provide customer support</li>
              <li>To improve our app and user experience</li>
              <li>To monitor app usage and analyze trends</li>
            </ul>
          </section>

          <section className="privacy-section">
            <h2>Data Sharing and Disclosure</h2>
            <p>
              We do not sell your personal information. We may share your information with:
            </p>
            <ul>
              <li>Service providers who assist in our operations</li>
              <li>Delivery personnel to complete your orders</li>
              <li>Legal authorities when required by law</li>
            </ul>
          </section>

          <section className="privacy-section">
            <h2>Data Security</h2>
            <p>
              We implement appropriate security measures to protect your personal information. 
              However, no method of transmission over the Internet is 100% secure.
            </p>
          </section>

          <section className="privacy-section">
            <h2>Your Data Protection Rights</h2>
            <p>You have the right to:</p>
            <ul>
              <li>Access your personal data</li>
              <li>Request correction of your data</li>
              <li>Request deletion of your data</li>
              <li>Object to processing of your data</li>
              <li>Request data portability</li>
              <li>Withdraw consent</li>
            </ul>
          </section>

          <section className="privacy-section">
            <h2>Children's Privacy</h2>
            <p>
              Our service is not intended for users under 13. We do not knowingly collect 
              personal information from children under 13.
            </p>
          </section>

          <section className="privacy-section">
            <h2>Changes to This Privacy Policy</h2>
            <p>
              We may update our Privacy Policy from time to time. We will notify you of any changes 
              by posting the new Privacy Policy on this page.
            </p>
          </section>

          <section className="privacy-section">
            <h2>Contact Us</h2>
            <p>If you have any questions about this Privacy Policy, please contact us at:</p>
            <div className="contact-info">
              <p><strong>Email:</strong> <a href="mailto:support@jewelmartindia.com" className="contact-link">support@jewelmartindia.com</a></p>
             </div>
          </section>

          <section className="privacy-section">
            <h2>Account Deletion</h2>
            <p>
              If you wish to delete your SellDeliver account and all associated data, 
              please visit our{" "}
              <a href="https://www.jewelmartindia.com/jres-account-delete" className="contact-link">Account Deletion Page</a>{" "}
              or contact us directly at{" "}
              <a href="mailto:support@jewelmartindia.com" className="contact-link">support@jewelmartindia.com</a>.
            </p>
          </section>
        </div>

        <footer className="privacy-footer">
          <p>© {new Date().getFullYear()} SellDeliver. All rights reserved.</p>
          <p className="footer-note">
            Your privacy is important to us.
          </p>
        </footer>
      </div>
    </div>
  );
};

export default PrivacyPolicySellDeliver;